'use strict';

angular.module('app.deleteMention', [])
    .controller('deleteMentionCtrl', ['$scope', '$rootScope', '$modal', '$http', 'deleteMentionService', '$modalInstance',
        function ($scope, $rootScope, $modal, $http, deleteMentionService, $modalInstance) {
            $scope.modalInstance = $modalInstance;
		    $scope.confirmDelete = function (id) {
		        var req = {
		            url: $rootScope.apiUrl + 'mention/deleteMention/' + id,
		            method: 'DELETE'
		        }

		        $http(req).success(function (responseDeleteMention) {
		            $scope.deleteConfirmModalInstance.close();
		            $scope.mentionDetailsModalInstance.close();
		            $scope.loadData();
		        })
		            .error(function (data) {

		            });
		    }

		    $scope.closeModal = function () {
		         $modalInstance.close();
		    }
        }  
])